import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { verificationAPI } from "../utility/services/apiService";
import { validateFields } from "../utility/services/Validation";
import { createNotification } from "./Popup";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { messages } from "../utility/services/message";
import Header from "./layout/Header";
import NavBar from "./layout/NavBar";
import Footer from "./layout/Footer";
import { logout, setEmailInfo, setTabID } from "../utility/Common";

const EmailVerification = () => {
  useEffect(() => {
    setTabID()
  }, [])
  const navigate = useNavigate();
  const useLocationData = useLocation().state;
  const [phoneError, setPhoneError] = useState("");

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [formData, setFormData] = useState({
    ActionType: "1",
    Mobile: "",
    Action: "EmailVerification",
    TerritoryID: "",
    Email: "",
    Verification: "",
    DestinationID: "",
  });

  const [isCode, setIsCode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const isEneo = formData.TerritoryID === "3";

  const validationRules = {
    Email: {
      required: true,
      pattern: emailPattern,
      isConditionMet: true,
      errorMessage: "Barua pepe ni lazima",
      patternErrorMessage: "Barua pepe si sahihi",
    },
    Verification: {
      required: true,
      isConditionMet: isCode,
      errorMessage: "Verification code ni lazima",
    },
    Mobile: {
      required: true,
      isConditionMet: true,
      errorMessage: "Nambali ya simu ni lazima",
    },
    TerritoryID: {
      required: true,
      isConditionMet: true,
      errorMessage: "Eneo  ni lazima",
    },
    DestinationID: {
      required: true,
      isConditionMet: isEneo,
      errorMessage: "Eneo  ni lazima",
    },
  };
  const handleChange = (e) => {
    if (typeof e === "string") {
      setFormData((prevData) => ({
        ...prevData,
        Mobile: e,
      }));

      const error = validatePhoneNumber(e);
      setPhoneError(error);
      return;
    }

    const { name, value } = e.target || {};
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: trimmedValue,
    }));

    if (name === "Email") {
      let emailError = "";
      if (!trimmedValue) {
        emailError = "Barua pepe ni lazima";
      } else if (!emailPattern.test(trimmedValue)) {
        emailError = "Barua pepe si sahihi";
      }
      setErrors((prevErrors) => ({
        ...prevErrors,
        Email: emailError,
      }));
    }
  };

  const validatePhoneNumber = (phoneNumber) => {
    const parsedNumber = parsePhoneNumberFromString(`+${phoneNumber}`, "TZ");
    if (!parsedNumber || !parsedNumber.isValid()) {
      return "Simu ya mkononi si sahihi.";
    }
    return "";
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateFields(formData, validationRules);
    setErrors(validationErrors);

    if (phoneError) {
      createNotification({ type: "error", message: phoneError })();
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      verificationAPI(formData, "etd_app_start")
        .then((result) => {
          setIsLoading(false);
          if (result.code === 1) {
            if (result?.data[0]?.status === 2) {
              const emailInfo = result.data[0];
              setEmailInfo(emailInfo)
              navigate("/docmentVerification", {
                state: {
                  emailInfo: emailInfo,
                  useLocationData,
                },
              });
            } else if (result?.data[0]?.status === 1) {
              setFormData((prevFormData) => ({
                ...prevFormData,
                ActionType: "2",
              }));
              setIsCode(true);
            } else {
              const info = { type: "error", message: result?.message };
              createNotification(info)();
            }
          } else {
            const info = { type: "error", message: result?.message };
            createNotification(info)();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          const info = { type: "error", message: messages.networkError };
          createNotification(info)();
        });
    } else {
      createNotification("Form has errors")();
    }
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <br />
              <div className="col-sm-6 text-justify">
                <h5 className="page-header m-r-t-1">
                  <Link>Ombi la Hati ya Dharura (ETD)</Link>
                </h5>
                {!isCode && (
                  <h5 style={{ fontSize: "14px", lineHeight: "1.6" }}>
                    Wakati wa ujazaji wa ombi la Hati ya Dharura, unatakiwa
                    kuanza kwa kujaza taarifa zako za msingi zikiwemo,{" "}
                    <b>namba yako ya simu</b>, <b>eneo ulipo</b> na{" "}
                    <b>Barua pepe yako.</b>
                  </h5>
                )}
                {isCode && (
                  <h5 style={{ fontSize: "14px", lineHeight: "1.6" }}>
                    Hakiki Barua pepe yako kwa kuingiza <b>code</b> iliyotumwa
                    katika email uliyoitumia.
                  </h5>
                )}
              </div>
              <div className="col-sm-1"></div>
              <div className="col-sm-5">
                <h5 className="page-header m-r-t-1">
                  <Link>Taarifa za Msingi</Link>
                </h5>
                <form id="passport-application-form" onSubmit={handleSubmit}>
                  <div>
                    {!isCode && (
                      <div className="form-group field-passportbasicdetails-mobileno required">
                        <label
                          className="control-label"
                          htmlFor="passportbasicdetails-mobileno"
                        >
                          Nambari ya simu
                        </label>
                        <PhoneInput
                          country={"tz"}
                          enableSearch={true}
                          id="Mobile"
                          name="Mobile"
                          value={formData?.Mobile}
                          onChange={handleChange}
                          inputStyle={{ width: "100%", borderRadius: ".2rem" }}
                          required
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "time new roman",
                          }}
                        >
                          {phoneError}
                        </div>
                      </div>
                    )}
                  </div>
                  {!isCode && (
                    <div className="form-group field-passportbasicdetails-priority required">
                      <label
                        className="control-label"
                        htmlFor="passportbasicdetails-priority"
                      >
                        Eneo Alipo Mwombaji
                      </label>
                      <select
                        id="TerritoryID"
                        className="form-control"
                        name="TerritoryID"
                        value={formData.TerritoryID}
                        onChange={handleChange}
                      >
                        <option value="">Chagua</option>
                        <option value="1">TANZANIA BARA</option>
                        <option value="2">ZANZIBAR</option>
                        <option value="3">NJE YA NCHI (UBALOZINI)</option>
                      </select>
                      <div
                        type="invalid"
                        style={{
                          color: "red",
                          fontSize: "13px",
                          fontFamily: "time new roman",
                        }}
                      >
                        {errors.TerritoryID && <p>{errors.TerritoryID}</p>}
                      </div>
                    </div>
                  )}
                  {formData.TerritoryID === "3" && !isCode && (
                    <div className="form-group field-passportbasicdetails-DestinationID required">
                      <label
                        className="control-label"
                        htmlFor="passportbasicdetails-DestinationID"
                      >
                        Unapofikia/Destination
                      </label>
                      <select
                        id="DestinationID"
                        className="form-control"
                        name="DestinationID"
                        value={formData?.DestinationID}
                        onChange={handleChange}
                        aria-required="true"
                      >
                        <option value="">Chagua pahali unatakapofikia</option>
                        <option value="1">TANZANIA BARA</option>
                        <option value="2">ZANZIBAR</option>
                      </select>
                      <div
                        type="invalid"
                        style={{
                          color: "red",
                          fontSize: "13px",
                          fontFamily: "time new roman",
                        }}
                      >
                        {errors.DestinationID && <p>{errors.DestinationID}</p>}
                      </div>
                    </div>
                  )}
                  {/*---------------------------------------*/}

                  {isCode && (
                    <div className="form-group">
                      <label
                        className="control-label"
                        htmlhtmlFor="verificationCode"
                        style={{ color: "green" }}
                      >
                        Ingiza code kutoka kwenye Barua pepe yako
                      </label>
                      <input
                        type="text"
                        id="Verification"
                        className="form-control"
                        name="Verification"
                        value={formData?.Verification}
                        onChange={(e) => {
                          const uppercaseValue = e.target.value.toUpperCase();
                          const regex = /^[A-Z0-9]*$/;
                          if (
                            regex.test(uppercaseValue) ||
                            uppercaseValue === ""
                          ) {
                            handleChange({
                              target: {
                                name: e.target.name,
                                value: uppercaseValue,
                              },
                            });
                          }
                        }}
                      />
                      <div
                        type="invalid"
                        style={{
                          color: "red",
                          fontSize: "13px",
                          fontFamily: "time new roman",
                        }}
                      >
                        <i>
                          {errors?.Verification && (
                            <p>{errors?.Verification}</p>
                          )}
                        </i>
                      </div>
                    </div>
                  )}
                  {!isCode && (
                    <div>
                      <div className="form-group">
                        <label className="control-label" htmlhtmlFor="Email">
                          Ingiza barua pepe yako
                        </label>
                        <input
                          type="text"
                          id="Email"
                          className="form-control"
                          name="Email"
                          value={formData?.Email}
                          onChange={(e) => {
                            const regex = /^[a-zA-Z0-9.@_-]*$/; // Allowed characters
                            if (
                              regex.test(e.target.value) ||
                              e.target.value === ""
                            ) {
                              handleChange(e);
                            }
                          }}
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "time new roman",
                          }}
                        >
                          <i>{errors?.Email && <p>{errors?.Email}</p>}</i>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="box-footer">
                    <button
                      className="btn btn-default btn-label-next pull-right"
                      type="submit"
                    >
                      {isLoading ? "Subiri...  " : "Hifadhi na Endelea"} |{" "}
                      <i className="fa fa-angle-double-right"></i>
                    </button>
                    <br />
                    <div style={{ marginTop: "15px" }}></div>
                  </div>
                </form>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailVerification;
